<template>
  <div>
    <!-- 头部 -->
    <div class="headerTop">
      <div class="EC_width display_between height_100">
        <div></div>
        <div class="display_center_ud">
          <div class="headerTop_search" v-show="isseach">
            <img src="/image/index/search.png" @click="onsearch()" />
            <input type="text" name="" id="" value="" v-model="keywords" />
          </div>
          <div class="headerTop_login" v-show="AuthorId == 0">
            <img src="/image/index/indexren.png" style="width:14px;height:16px;margin-top: 3px;"
              class="headerTop_login_img" />
            <a style="margin-top: 3px;" @click="userlogin()">登陆</a>
            <span style="color: #fff; margin: 0 6px">|</span>
            <a style="margin-top: 3px;" @click="userRegister()">注册</a>
          </div>
          <div class="headerTop_login" v-show="AuthorId > 0" v-if="authorinfo != null">
            <router-link to="/user/userMymsg" style="position: relative;">
              <img style="margin-top: 3px;" src="/image/index/lingdangset.png" alt="" class="headerTop_login_img" />
              <span class="msgnum" v-show="unreadmsg > 0">{{ unreadmsg }}</span>
            </router-link>
            <div @click.capture="taggleinfor = true" style="cursor: pointer;position: relative;">
              <img class="headerTop_login_img" :src="authorinfo.avatarUrl" alt=""
                style="vertical-align: -4px; border-radius: 50%" width="24" height="24" />
              <img src="../../assets/img/v.png" class="viplogpo" alt="" v-if="userType == 2" />
              <img src="../../assets/img/s.png" class="viplogpo" alt="" v-if="userType == 1" />
              <span style="color: #fff">{{ authorinfo.nickname != '' ? authorinfo.nickname : authorinfo.mobile }}</span>
            </div>
            <div class="opra" v-show="taggleinfor" @click.stop="setClick">
              <div class="text_right" style="position: relative;">
                <img src="/image/index/shangjiao.png" alt="" class="ArrowTop" />
              </div>

              <div class="display_flex">
                <!-- <img src="/image/index/stateHead.png" /> -->
                <img :src="authorinfo.avatarUrl" @click="$router.push({ name: 'userInfor' })" class="img-border" />
                <div class="flex1 marginLeft10">
                  <p class="marginTop10 marginBottom10">
                    {{ authorinfo.nickname != '' ? authorinfo.nickname : authorinfo.mobile }}
                    <router-link to="/user/userMyInforShow">
                      <span class="informy" style="cursor: pointer">
                        个人资料
                      </span>
                    </router-link>
                    <!-- </a> -->
                  </p>
                  <p>
                    <img src="/image/index/phoneIcon.png" alt="" />
                    {{ authorinfo.mobile }}
                  </p>
                </div>
                <div>
                  <span class="out" @click="out">退出</span>
                </div>
              </div>
              <div class="vip display_between marginTop20">
                <div v-if="userType == 0" class="display_center_ud">
                  <img src="../../assets/img/svip.png" style="width:38px" alt="" />
                  <span class="marginLeft10 redColor">全站通-198元</span>
                  <span>/年</span>
                </div>
                <div v-else class="display_center_ud">
                  <img style="width:38px" src="../../assets/img/svip.png" alt="" />
                  <span class="marginLeft10 redColor" style="font-size:14px">{{ userType == 1 ? 'SVIP' : 'VIP' }}到期时间：{{
                    authorinfo.memberDate.m_EndDate.substr(0, 10)
                    }}</span>
                  <!-- <span>/年</span> -->
                </div>
                <div class="kaitong">
                  <span v-if="userType == 0" style="cursor: pointer">
                    <router-link to="/user/userVip">
                      立即开通
                    </router-link>
                  </span>
                  <span v-else-if="userType == 1" style="cursor: pointer">
                    <router-link to="/user/userVip">
                      立即续费
                    </router-link>
                  </span>
                  <span v-else-if="userType == 2" style="cursor: pointer">
                    <router-link to="/user/userVip">
                      立即升级
                    </router-link>
                  </span>
                </div>
              </div>
              <div class="display_between marginTop20">
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userMyOrder" style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu01.png" alt="" />
                    <div class="marginTop10" style="color:black">我的订单</div>
                  </router-link>
                </div>
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userMyCourse" style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu02.png" alt="" />
                    <div class="marginTop10" style="color:black">我的课程</div>
                  </router-link>
                </div>
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userMyCollection"
                    style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu03.png" alt="" />
                    <div class="marginTop10" style="color:black">我的收藏</div>
                  </router-link>
                </div>
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userVip" style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu04.png" alt="" />
                    <div class="marginTop10" style="color:black">VIP中心</div>
                  </router-link>
                </div>
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userMyMeeting"
                    style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu05.png" alt="" />
                    <div class="marginTop10" style="color:black">我的会议</div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="modal" v-if="taggleinfor" @click="taggleinfor = false"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="header EC_width display_between">
      <div class="logoWrap display_center_ud">
        <router-link id="home" to="/home">
          <img style="height:80px" src="/image/index/indexlogo5.png" />
        </router-link>
      </div>
      <div class="display_flex" style="font-size: 18px;">
        <div class="menu_item" :class="{ menu_item_active: currentindex == 0 }">
          <a href="javascript:void(0)" @click="$router.push({ name: 'home', query: { n: 1 } })">首页</a>
        </div>
        <div class="menu_item" :class="{ menu_item_active: currentindex == 1 }">
          <a href="javascript:void(0)" @click="$router.push({ name: 'grassheal' })">
            基层卫生
          </a>
        </div>
        <div class="menu_item">
          <a :href="httphelper.IsDebugCgphome() + '/home'" target="_blank">全科知家</a>
        </div>
        <div v-if="!isDebug" class="menu_item" :class="{ menu_item_active: currentindex == 4 }">
          <a href="javascript:void(0)" @click="navclick">学术会议</a>
        </div>
        <div v-else class="menu_item" :class="{ menu_item_active: currentindex == 4 }">
          <a href="javascript:void(0)" @click="$router.push({ name: 'meeting' })">
            学术会议
          </a>
        </div>
        <!-- <div class="menu_item" :class="{ menu_item_active: currentindex == 5 }">
          <a href="javascript:void(0)" @click="$router.push({ name: 'disciconstruc' })">
            学科建设
          </a>
        </div>
        <div class="menu_item" :class="{ menu_item_active: currentindex == 2 }">
          <a href="javascript:void(0)" @click="$router.push({ name: 'journal' })">
            杂志专区
          </a>
        </div>
        <div class="menu_item" :class="{ menu_item_active: currentindex == 6 }">
          <a href="https://rd.gp519.com/" target="_blank">
            科研服务
          </a>
        </div> -->
        <div class="menu_item menu_item_dropdown"
          :class="{ menu_item_active: [2, 5, 6].includes(currentindex), open: showInstituteMenu }"
          @mouseenter="showInstituteMenu = true"
          @mouseleave="showInstituteMenu = false">
          <a class="dropdown_toggle" href="javascript:void(0)" @click.prevent="toggleInstituteMenu">
            <span>全科研究院</span>
            <span class="dropdown_arrow" :class="{ expanded: showInstituteMenu }"></span>
          </a>
          <div class="dropdown_menu" v-show="showInstituteMenu">
            <a href="javascript:void(0)" @click.prevent="navigateInstitute('disciconstruc')">
              学科建设
            </a>
            <a href="javascript:void(0)" @click.prevent="navigateInstitute('journal')">
              杂志专区
            </a>
            <a href="https://rd.gp519.com/" target="_blank" rel="noopener">
              科研服务
            </a>
          </div>
        </div>
        <!-- <div style="line-height: 90px">
          <span style="color: #ddd; margin: 0 16px">|</span>
        </div> -->
        <div class="menu_item">
          <a href="https://cpcprn.cgphome.com" target="_blank">中国基层医疗科研协作网</a>
        </div>
        <div class="menu_item">
          <a href="https://fmch.gp519.com/e-journal/enhome" target="_blank">BMJ-FMCH</a>
        </div>
       <div class="menu_item" :class="{ menu_item_active: currentindex == 9 }">
            <a href="javascript:void(0)" @click.prevent="navigateInstitute('popsci')">科普专区</a>
        </div>
        <div class="menu_item_style">
          <!-- <a href="javascript:void(0)"
             @click="dialogTableVisible=true">
            投稿
          </a> -->
          <a href="javascript:void(0)" style="display: none;"
            @click="tougao('http://zgqkyxauthor.manuscriptcloud.com/login')">
            投稿
          </a>
        </div>
      </div>
    </div>
    <div class="chaxun">
      <el-dialog title="投稿查询" :visible.sync="dialogTableVisible" style="margin-top: 10%;">
        <el-button type="success" plain
          @click="tougao('http://qkhy.bosihw.cn/Admin/user/login/')">2022年海医会年会投稿查询</el-button>
        <el-button type="primary" plain
          @click="tougao('http://zgqkyxauthor.manuscriptcloud.com/login')">《中国全科医学》杂志投稿查询</el-button>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header_index',
  data() {
    return {
      currentindex: 0,
      taggleinfor: false,
      loginStaus: false,
      authorinfo: null,
      keywords: '',
      AuthorId: 0,
      isDebug: true,
      isseach: true,
      unreadmsg: 0,
      userType: 0,
      dialogTableVisible: false,
      showInstituteMenu: false
    };
  },
  watch: {
    $route(to) {
   
      if (to.meta.activeNum != undefined) {
        this.currentindex = to.meta.activeNum;
      }
      if (to.name != 'searchPage') {
        this.isseach = true;
      } else {
        this.isseach = false;
      }
    }
  },
  created() {
    if (this.$route.name != 'searchPage') {
      this.isseach = true;
    } else {
      this.isseach = false;
    }
  },
  mounted() {
    if (this.$route.meta.activeNum != undefined) {
      this.currentindex = this.$route.meta.activeNum;
    }
    if (this.$cookies.isKey('token_chinagp')) {
      var _tokenkey = this.$cookies.get('token_chinagp');
      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: _tokenkey
        })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.setItem('nickname', res.data.data.nickname);
            localStorage.setItem('ResData', JSON.stringify(res.data.data));
            var aData = new Date();
            var CurrentDategetTime = 0
            var VipEdDategetTime = 0
            if (res.data.data.memberDate.m_EndDate) {
              var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
              var VipEdDate = res.data.data.memberDate.m_EndDate;
              CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
              VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
            }
            if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
              this.userType = 0;
            } else {
              if (res.data.data.memberDate.m_Type == 1) {
                this.userType = 1;
              } else if (res.data.data.memberDate.m_Type == 2) {
                this.userType = 2;
              } else {
                this.userType = 0;
              }
            }
            localStorage.setItem('userType', this.userType);
            this.loginStaus = true;
            this.AuthorId = res.data.data.id;
            this.authorinfo = res.data.data;
            // window.location.reload();
            this.httphelper
              .post('/api/MessageApi/GetNewMessageCount', {
                userId: this.AuthorId,
              })
              .then(res => {
                this.unreadmsg = res.data.data;
              });
          } else {
            localStorage.clear();
            this.$cookies.remove('token_chinagp');
            // window.location.reload();
          }
        });
    } else {
      localStorage.clear();
      this.$cookies.remove('token_chinagp');
      // window.location.reload();
    }
  },
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next(vm => {
      if (to.meta.activeNum != undefined) {
        vm.currentindex = to.meta.activeNum;
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to.meta.activeNum != undefined) {
      this.currentindex = to.meta.activeNum;
    }
    this.showInstituteMenu = false;
    next();
  },
  methods: {
    setClick() { },
    tougao(url) {
      this.dialogTableVisible = false;
      window.open(url);
    },
    out() {
      this.taggleinfor = false;
      this.loginStaus = false;
      this.AuthorId = 0;
      this.outClearToken();
    },
    userlogin() {
      let routeUrl = this.$router.resolve({
        path: '/loginIndex/login'
      });
      window.location.href = routeUrl.href;
      //   window.open(routeUrl.href, '_blank')
    },
    userRegister() {
      // this.taggleinfor=true
      let routeUrl = this.$router.resolve({
        path: '/loginIndex/loginRegister'
      });
      window.location.href = routeUrl.href;
      //   window.open(routeUrl.href, '_blank')
    },
    onsearch() {
      this.$router.push({
        name: 'searchPage',
        params: { labelname: this.keywords }
      });
    },
    navclick() {
      this.$msgmodal({
        title: '系统提示',
        content: '建设中...',
        type: 'warn'
      });
    },
    toggleInstituteMenu() {
      this.showInstituteMenu = !this.showInstituteMenu;
    },
    navigateInstitute(routeName) {
      this.showInstituteMenu = false;
      this.$router.push({ name: routeName });
    },
    outClearToken() {
      var _tokenkey = this.$cookies.get('token_chinagp');
      this.httphelper.post('/api/LoginApi/ClearToken', {
        tokenKey: _tokenkey
      })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.clear();
            this.$cookies.remove('token_chinagp');
            location.reload();
          }
        })
    },
    checkToken() {
      var _tokenkey = this.$cookies.get('token_chinagp');
      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: _tokenkey
        })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.setItem('nickname', res.data.data.nickname);
            var aData = new Date();
            var CurrentDategetTime = 0
            var VipEdDategetTime = 0
            if (res.data.data.memberDate.m_EndDate) {
              var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
              var VipEdDate = res.data.data.memberDate.m_EndDate;
              CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
              VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
            }
            if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
              this.userType = 0;
            } else {
              if (res.data.data.memberDate.m_Type == 1) {
                this.userType = 1;
              } else if (res.data.data.memberDate.m_Type == 2) {
                this.userType = 2;
              } else {
                this.userType = 0;
              }
            }
            localStorage.setItem('userType', this.userType);
            localStorage.setItem('ResData', JSON.stringify(res.data.data));
            return true;
          }
          return false;
        });
    }
  }
};
</script>

<style scoped>
/* 页面的顶部搜索条 */
.headerTop {
  height: 34px;
  background: linear-gradient(90deg, #0e3853, #01787a);
  min-width: 1240px;
}

.headerTop_home {
  color: #fff;
  font-size: 14px;
}

.headerTop_search {
  position: relative;
}

.headerTop_search input {
  width: 200px;
  height: 26px;
  outline: none;
  border-radius: 26px;
  box-sizing: border-box;
  padding-left: 20px;
}

.headerTop_search img {
  position: absolute;
  right: 13px;
  top: 4px;
  cursor: pointer;
}

.headerTop_login {
  position: relative;
  display: flex;
}

.headerTop_login a {
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}

.headerTop_login_img {
  margin-left: 20px;
  margin-right: 6px;
  vertical-align: -2px;
}

/* 头部样式 */
.header {
  height: 90px;
  display: flex;
  min-width: 1240px;
}

.logoWrap {
  /* width: 340px; */
  width: 280px;
  margin-left: 0px;
}

.menu_item {
  padding: 0 1rem;
  line-height: 90px;
  overflow: hidden;
  box-sizing: border-box;
}

.menu_item_dropdown {
  position: relative;
  overflow: visible;
}

.dropdown_menu {
  display: none;
  position: absolute;
  top: 90px;
  left: 0;
  min-width: 180px;
  padding: 16px 0;
  background: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  z-index: 30;
}

.menu_item_dropdown.open .dropdown_menu {
  display: block;
}

.dropdown_menu a {
  display: block;
  padding: 8px 24px;
  line-height: 1.5;
  color: #333;
  font-weight: normal;
  white-space: nowrap;
}

.dropdown_menu a:hover {
  background: #f5f5f5;
  color: #0b8485;
}

.menu_item_style {
  padding: 0 20px;
  line-height: 90px;
  box-sizing: border-box;
}

.menu_item_style a {
  width: 80px;
  height: 34px;
  color: #fff;
  line-height: 34px;
  text-align: center;
  display: inline-block;
  border-radius: 36px;
  background: #b70109;
}

.menu_item a {
  color: #333;
  font-weight: bold;
  white-space: nowrap;
}

.dropdown_toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.dropdown_arrow {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #888;
  transition: transform 0.2s ease, border-top-color 0.2s ease;
}

.menu_item_active .dropdown_arrow {
  border-top-color: #0b8485;
}

.dropdown_arrow.expanded {
  transform: rotate(180deg);
  border-top-color: #0b8485;
}

.menu_item_active {
  border-bottom: 3px solid #0b8485;
}

.menu_item_active a {
  color: #0b8485;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
}

.opra {
  padding: 25px;
  display: inline-block;
  position: absolute;
  background: #fff;
  width: 400px;
  box-sizing: border-box;
  right: 0px;
  top: 29px;
  box-shadow: 0px 5px 15px 0px rgba(6, 50, 52, 0.2);
  border-radius: 3px;
  z-index: 100;
}

.out {
  padding: 2px 8px;
  border: 1px solid #c8c8c8;
  border-radius: 10px;
  cursor: pointer;
}

.informy {
  width: 77px;
  height: 25px;
  background: #0b8586;
  border-radius: 13px;
  display: inline-block;
  text-align: center;
  line-height: 25px;
  color: #fff;
  margin-left: 5px;
}

.vip {
  height: 50px;
  background: url('/image/index/gerenbar.png');
  padding: 0 6px;
}

.kaitong {
  width: 96px;
  height: 29px;
  background: linear-gradient(90deg, #ff1e00, #ff6600);
  border-radius: 14px;
  text-align: center;
  line-height: 29px;
  color: #fff;
}

.ArrowTop {
  position: absolute;
  top: -30px;
}

.img-border {
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  width: 60px;
  height: 60px;
  cursor: pointer;
}

.viplogpo {
  width: 12px;
  height: 12px;
  position: absolute;
  left: 36px;
  top: -2px;
  z-index: 9;
}

.msgnum {
  position: absolute;
  left: 35px;
  top: -5px;
  background-color: rgb(207, 19, 19);
  color: #fff;
  padding: 0px 2px 1px;
  border-radius: 8px;
}

.chaxun ::v-deep .el-dialog {
  width: 503px;
}
</style>
